import { io } from "socket.io-client";
import log from "cslog";
import { useState } from "react";
import { useAtom, useSetAtom } from "jotai";
import { messageListAtom } from "../atoms";
import { restoreAccessToken } from "../../_helpers/auth";

// "undefined" means the URL will be computed from the `window.location` object
// const URL = process.env.NODE_ENV === 'production' ? undefined : 'http://localhost:4000';
//
export const URL = "https://botapi.qureal.com";
// export const URL = "http://localhost:8000";

export const socket = io(URL, {
    autoConnect: false,
    path: "/websoc/socket.io",
    transports: ["websocket"],
    auth: {
        token: restoreAccessToken(),
    },
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 5,
    timeout: 5000,
});
